import { FC } from 'react';
import { TPointSummary } from '../../../mapTypes';
import { formatValueAsString } from '../../../../../utils/helpers';

interface IPortCallPopupContentProps {
	info: TPointSummary;
	options: Intl.NumberFormatOptions;
}

const PortCallPopupContent: FC<IPortCallPopupContentProps> = ({ info, options }) => (
	<>
		<div>
			<span className="font-bold">Activity : </span>
			<span>{info?.portActivity}</span>
		</div>
		<div>
			<span className="font-bold">Port : </span>
			<span>{info?.portName}</span>
		</div>
		<div>
			<span className="font-bold">Start Time : </span>
			<span>{new Date(info?.startTime!).toLocaleString()}</span>
		</div>
		<div>
			<span className="font-bold">End Time : </span>
			<span>{new Date(info?.endTime!).toLocaleString()}</span>
		</div>
		<div>
			<span className="font-bold">Total Time (Days) : </span>
			<span>{formatValueAsString(info?.totalTimeInPort, options, '', '', ' ')}</span>
		</div>
	</>
);

export default PortCallPopupContent;
